module.exports = __webpack_public_path__ + "img/icon_content_list_bottom.978452be.png";